<div class="signout-container">
    <img src="assets/images/SignOut.svg" alt="">
    <p>Are you sure want to logout?</p>
    <div class="footer-btn">
        <button class="cancel-btn" (click)="cancel()">Cancel</button>
        <button class="logout-btn" (click)="logout()">Logout</button>
    </div>
</div>